import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    name: String,
  };

  async dismiss(event) {
    // Prevent immediate dismissal
    event.preventDefault();

    const button = event.currentTarget;
    const originalText = button.textContent;

    // Show loading state
    button.disabled = true;
    button.textContent = 'Dismissing...';

    try {
      await this.#sendDismissalRequest();
      // Only remove the modal after successful backend dismissal
      this.element.remove();
    } catch (error) {
      console.error('Failed to dismiss notification:', error);
      // Reset button state on error
      button.disabled = false;
      button.textContent = originalText;
      // Still remove the modal to avoid it being stuck
      this.element.remove();
    }
  }

  #sendDismissalRequest() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const data = {
      notification: {
        name: this.nameValue,
      },
    };

    return fetch('/notifications', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json; charset=utf-8',
        'X-CSRF-Token': csrfToken,
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response;
    });
  }
}
